import React, { useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { CustomPanel, CustomTabView, PageHeader, Periodo } from '../../../../components'
import { TabPanel } from 'primereact/tabview'
import DevolucaoParcialPendente from '../DevolucaoParcialPendente/DevolucaoParcialPendente'
import DevolucaoTotalPendente from '../DevolucaoTotalPendente/DevolucaoTotalPendente'
import SobraPendente from '../SobraPendente/SobraPendente'
import { selectOcorrencia } from '../../../../store/actions/ordem-coleta.actions'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { useOcorrenciasPendentesContext } from '../../../../contexts/OrdemColetaContext'

function OcorrenciasPendentes({ history, dispatch, selectedTp, tabIndex }) {
  // Vars
  const { ordem } = history.location.state

  // Hooks
  const { ocorrenciasPendentesContext, setOcorrenciasPendentesContext } =
    useOcorrenciasPendentesContext()
  const [periodo, setPeriodo] = useState(ocorrenciasPendentesContext.selectedPeriodo)

  // Events
  const onPesquisar = (pInicial, pFinal) => {
    const isDataValida = data => data instanceof Date && !isNaN(data.getTime())
    if (!isDataValida(pInicial) || !isDataValida(pFinal)) {
      dispatch(showMessageBox(null, 'Informe a Data de Operação Inicial e Final'))
      return
    }
    setPeriodo({ pInicial, pFinal })
    setOcorrenciasPendentesContext(prevContext => ({
      ...prevContext,
      selectedPeriodo: { pInicial, pFinal },
    }))
  }

  // Helpers

  // Render ...
  return (
    <React.Fragment>
      <PageHeader>
        Ocorrências
        <strong> &nbsp; Pendentes</strong>
        &nbsp; - Ordem Selecionada:
        <strong>&nbsp; {ordem.descricao}</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={() => history.goBack()}>
          <div style={{ marginBottom: 15 }}>
            <label style={{ fontWeight: 'bold' }}>Data de Operação</label>
            <Periodo
              periodoInicial={periodo.pInicial}
              periodoFinal={periodo.pFinal}
              onPesquisar={onPesquisar}
            />
          </div>
          <CustomTabView
            activeIndex={tabIndex}
            onTabChange={index => dispatch(selectOcorrencia(index, ''))}
          >
            <TabPanel header="Sobras" disabled={false}>
              <SobraPendente
                tpId={selectedTp}
                ordemColetaId={ordem.id}
                companyId={ordem.company_id}
                pInicial={periodo.pInicial}
                pFinal={periodo.pFinal}
              />
            </TabPanel>
            <TabPanel header="Devolução Parcial" disabled={false}>
              <DevolucaoParcialPendente
                ordemColetaId={ordem.id}
                companyId={ordem.company_id}
                tpId={selectedTp}
                pInicial={periodo.pInicial}
                pFinal={periodo.pFinal}
              />
            </TabPanel>
            <TabPanel header="Devolução Total" disabled={false}>
              <DevolucaoTotalPendente
                ordemColetaId={ordem.id}
                companyId={ordem.company_id}
                tpId={selectedTp}
                pInicial={periodo.pInicial}
                pFinal={periodo.pFinal}
              />
            </TabPanel>
          </CustomTabView>
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = ({ system: { selectedTp }, ordem_coleta: { tabIndex } }) => ({
  selectedTp,
  tabIndex,
})
export default connect(mapStateToProps)(withRouter(OcorrenciasPendentes))
